export default __webpack_public_path__ + "static/media/architecture1Eng.91819e52.jpg";